﻿import StNavbar from './StNavbar.vue';
import { mountAppStudioPage } from './Vue3/app-studio-page-mount';

mountAppStudioPage({
    root: '#navbar-vue-container',
    propsElement: '#navbar-props',
    component: StNavbar
});
